export const PREDEFINED_ROW = [
  {
    __children: [],
  },
]
